module.exports = __webpack_public_path__ + "static/media/migrate_lp.b5a0c6cb.svg";